module.exports = __webpack_public_path__ + "media/SndWrong.6054c57f.mp3";